import React from 'react'


function Stock({ variation }) {

    const instock = (variation) => {
        if (variation.quantity > 0) {
            return true
        } else if (variation.backorder) {
            return true
        } else {
            return false
        }
    }

    return (
        <>

            {instock(variation) ? (
                <>
                    {(variation.quantity > 0) ? (
                        <div className="text-emerald-600 flex items-center font-medium text-s">
                            <i className="fas fa-check-circle mr-1"></i> {(variation.quantity > 50 ? '50+' : variation.quantity)} In Stock
                        </div>
                    ) : ('')}
                </>
            ) : (
                <>
                    <div className="text-red-500 flex items-center font-medium text-sm">
                        <i className="fas fa-check-circle"></i>
                        Out Of Stock
                    </div>
                </>
            )}
            {(variation.sku) ? (
                <span className="text-gray-500 font-medium text-xs">Advanced Water Code: {variation.sku}</span>
            ) : ('')}
        </>
    );
}

export default Stock;